"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOffsetAndLimit = exports.getInitPageNumberAndType = exports.isPaginatedPage = exports.getPaginatedTypeFromHistory = exports.getNewPaginationPage = void 0;
var lodash_1 = require("lodash");
var core_1 = __importStar(require("@gin-betting/core"));
var types_1 = require("./types");
var constants_1 = require("./constants");
var _a = core_1.default.utils, getFiltersFromLocation = _a.getFiltersFromLocation, getRouteFromHistory = _a.getRouteFromHistory;
function getNewPaginationPage(data) {
    var oldPage = data.oldPage, page = data.page, isVisible = data.isVisible, bottom = data.bottom, direction = data.direction;
    if (page === 1 && oldPage === 1) {
        /* specific case - very first page, can move only downwards from here */
        return {
            newPage: page,
            newDirection: types_1.ScrollDirection.DOWN, // can not go anywhere else from here but downwards
        };
    }
    /* page was loaded but not appear yet, pagination shouldn't change */
    if (!isVisible && !bottom && page > oldPage) {
        return { newPage: oldPage, newDirection: direction };
    }
    if (isVisible && bottom) {
        var newDirection = page <= oldPage
            ? /* scrolling to the same direction */
                direction
            : /* scrolling downwards */
                types_1.ScrollDirection.DOWN;
        return { newPage: page, newDirection: newDirection };
    }
    /* scrolling only upwards */
    var previousPage = oldPage > 2 ? oldPage - 1 : 1;
    return {
        newPage: previousPage,
        newDirection: types_1.ScrollDirection.UP,
    };
}
exports.getNewPaginationPage = getNewPaginationPage;
function getPaginatedTypeFromHistory(routes) {
    var route = getRouteFromHistory();
    if (!routes.includes(route))
        return;
    return route;
}
exports.getPaginatedTypeFromHistory = getPaginatedTypeFromHistory;
function isPaginatedPage(routes) {
    var route = getPaginatedTypeFromHistory(routes);
    if (lodash_1.includes(constants_1.ROUTES_WITHOUT_PAGINATION, route))
        return false;
    return !!route;
}
exports.isPaginatedPage = isPaginatedPage;
function getInitPageNumberAndType(routes) {
    var searchObj = getFiltersFromLocation();
    return {
        TYPE: getPaginatedTypeFromHistory(routes),
        PAGE: lodash_1.toNumber(lodash_1.get(searchObj, 'page', 1)) || 1,
    };
}
exports.getInitPageNumberAndType = getInitPageNumberAndType;
function calculateOffsetAndLimit(listType, options) {
    var pagination = options.pagination, isPolling = options.isPolling, isLoadMore = options.isLoadMore;
    var _a = pagination[listType], minPage = _a.minPage, maxPage = _a.maxPage, limitPerPage = _a.limitPerPage;
    var direction = pagination.direction, initialLoad = pagination.initialLoad, pollingEdgePage = pagination.pollingEdgePage;
    /* customInitialLoad needed to separate expectations
    of loading two pages from single page */
    var customInitialLoad = initialLoad && maxPage > 1;
    var minOffset = (minPage - 1) * limitPerPage;
    var maxOffset = (maxPage - 1) * limitPerPage;
    var isUp = direction === types_1.ScrollDirection.UP;
    /* minimum offset for previous page, first load and no "load-more" */
    var newOffset = isUp || initialLoad || !isLoadMore ? minOffset : maxOffset;
    var maxLimit = (maxPage - minPage + 1) * limitPerPage;
    var newLimit = customInitialLoad || !isLoadMore ? maxLimit : limitPerPage;
    /* when successfully loaded need to know where to put result */
    var prepend = isUp;
    /* either it's first page or every polling-ish page */
    var pollingLimit = maxPage > 1 ? limitPerPage * pollingEdgePage : limitPerPage;
    return isPolling
        ? { offset: minOffset, limit: pollingLimit }
        : { offset: newOffset, limit: newLimit, prepend: prepend, customInitialLoad: customInitialLoad };
}
function getOffsetAndLimit(options, routes) {
    var paginationPage = getPaginatedTypeFromHistory(routes);
    if (!paginationPage)
        return {};
    switch (paginationPage) {
        case core_1.App.Routes.OUTRIGHTS_LIST: {
            return options.pagination[core_1.App.Routes.OUTRIGHTS_LIST];
        }
        default: {
            return calculateOffsetAndLimit(paginationPage, options);
        }
    }
}
exports.getOffsetAndLimit = getOffsetAndLimit;
//# sourceMappingURL=utils.js.map